import { combineReducers } from 'redux';

import currentUser from './currentUser';

const rootUserManagementReducer = combineReducers({
  currentUser,
});

export default rootUserManagementReducer;
